export const excludeMenuList = ['online-course', 'notify', 'video', 'enquiry'];
export const gradeList = ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'S1', 'S2', 'S3', 'S4', 'S5', 'S6', 'junior_high_school', 'high_school', 'primary'];
export const settingInterval = 30;